/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetGraphToolsService extends BaseService {
  constructor() {
    super(constants.GET_AGENTIC_TOOLS, 'agenticToolsStatus');
  }

  getErrorMessage(data, fallback) {
    return data?.error || data?.message || fallback;
  }

  sortTools(tools) {
    if (!Array.isArray(tools)) return [];

    return [...tools].sort((a, b) => {
      const aCustom = !!(a && a.custom);
      const bCustom = !!(b && b.custom);
      if (aCustom !== bCustom) return aCustom ? -1 : 1; // custom: true first
      const aLabel = (a && a.label ? String(a.label) : '').toLowerCase();
      const bLabel = (b && b.label ? String(b.label) : '').toLowerCase();
      return aLabel.localeCompare(bLabel);
    });
  }

  async handleEvent(eventName, event) {
    const { headers } = utils.buildRequestPartsFromPayload(event);

    // `headers` will include x-berlin-tenant-id when `tenantId` is passed in event.payload
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get('/graphs/tools', { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get('/graphs/tools', { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const agenticToolsModel = Framework.getStoreRegistry().getStore('agenticToolsModel');

    if (data && data.success) {
      const sortedTools = this.sortTools(data.tools);
      const responseData = { ...data, tools: sortedTools };

      agenticToolsModel.setToolsData(responseData);
      Framework.getEventManager().publish(constants.GET_AGENTIC_TOOLS_SUCCESS, {
        data: responseData
      });
    } else {
      const msg = this.getErrorMessage(data, 'Error fetching tools');
      agenticToolsModel.setError(msg);
      Framework.getEventManager().publish(constants.GET_AGENTIC_TOOLS_ERROR, {
        message: msg
      });
    }
  }

  handleError(error) {
    const agenticToolsModel = Framework.getStoreRegistry().getStore('agenticToolsModel');
    const { response } = error;

    const msg = response?.data?.error || response?.data?.message || 'Error fetching tools';

    agenticToolsModel.setError(msg);
    Framework.getEventManager().publish(constants.GET_AGENTIC_TOOLS_ERROR, {
      message: msg
    });
  }
}
